import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router, Scroll } from '@angular/router';
import { takeUntil } from 'rxjs';
import { AuthService } from 'src/app/auth/services';
import { BaseComponent } from 'src/app/shared/components/base-component/base.component';
import { CommonService } from 'src/app/shared/services';
import { MenuItems, ToggleDirections } from './header.model';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent extends BaseComponent implements OnInit {
  @Input() toggleDirection: ToggleDirections = ToggleDirections.LEFT;

  currentActiveParentRoute!: string;

  menuItems = MenuItems;
  toggleDirections = ToggleDirections;
  showSidebar = false;
  showProgressBar = false;

  constructor(
    private readonly router: Router,
    private readonly cdr: ChangeDetectorRef,
    private readonly authService: AuthService,
    private readonly commonService: CommonService
  ) {
    super();
    this.setActiveRoute();
  }

  ngOnInit(): void {
    this.getCurrentUser();
  }

  subscribeToAPICallProgress(): void {
    //Call this method to show global progress bar
    this.commonService.isApiCallInProgress$.pipe(takeUntil(this.destroy$)).subscribe((isApiCallInProgress) => {
      this.showProgressBar = isApiCallInProgress;
      this.cdr.detectChanges();
    });
  }

  getCurrentUser(): void {
    if (!this.authService.currentUser) {
      this.authService
        .getCurrentUser()
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res) => {
            this.currentUser = res;
            if (this.currentUser) {
              this.authService.setCurrentUser$(this.currentUser);
            }
          }
        });
    }
    this.cdr.detectChanges();
  }

  setActiveRoute(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentActiveParentRoute = event.url.split('/')[1];
      } else if (event instanceof Scroll) {
        this.currentActiveParentRoute = event.routerEvent.url.split('/')[1];
      }
      this.cdr.detectChanges();
    });
  }
}
